module.exports = "<h3>{{ctrl.kontakt.nazov}}</h3>"


//////////////////
// WEBPACK FOOTER
// ./src/Menu/ClientDetails.html
// module id = 273
// module chunks = 0